import pluralize from '@sravni/utils/lib/pluralize';

export const getWeeksPluralize = (value: number) => pluralize(value, 'неделя', 'недели', 'недель') ?? 'неделя';
